import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { ShieldCheck, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAdminAuth } from "@/lib/admin-auth-context";
import { useToast } from "@/hooks/use-toast";

export default function AdminSigninPage() {
  const { signin } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { toast } = useToast();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const from = location.state?.from || "/admin";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signin(email.trim().toLowerCase(), password);
      toast({ title: "Welcome back, admin" });
      navigate(from, { replace: true });
    } catch (err) {
      toast({
        title: "Sign in failed",
        description: err?.response?.data?.detail || "Invalid credentials",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6 py-10">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex w-12 h-12 rounded-2xl bg-primary text-primary-foreground items-center justify-center mb-6">
            <ShieldCheck className="w-6 h-6" />
          </div>
          <h1 className="font-serif text-3xl font-bold">Admin sign in</h1>
          <p className="text-muted-foreground mt-2">Cravve operations console.</p>
        </div>
        <form onSubmit={submit} className="bg-card border rounded-2xl p-6 space-y-4 shadow-sm">
          <div className="space-y-2">
            <Label htmlFor="a-email">Email</Label>
            <Input id="a-email" type="email" autoComplete="username" required value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@cravve.app" data-testid="admin-signin-email" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="a-pw">Password</Label>
            <Input id="a-pw" type="password" autoComplete="current-password" required value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••" data-testid="admin-signin-password" />
          </div>
          <Button type="submit" className="w-full h-11 font-semibold" disabled={loading} data-testid="admin-signin-submit">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign in"}
          </Button>
        </form>
        <p className="text-center mt-6 text-xs text-muted-foreground">
          <Link to="/" className="hover:underline">← Back to Cravve</Link>
        </p>
      </div>
    </div>
  );
}
